// extracted by mini-css-extract-plugin
export default {"button":"styles_button__whzyP","disabled":"styles_disabled__8KS6Z"};